import React from 'react';
import { callApi } from '../../../Utils/Api/Api';
import MicrosoftLogo from '../../../assets/logo/microsoft-logo.png';
import { Button } from '@progress/kendo-react-buttons';

const AzureLoginButton = ({ setIsLoader, setAlertMessage }) => {
  const handleSocialLogin = async (driver) => {
    setIsLoader(true);
    try {
      const response = await callApi(`/social/auth/URL?driver=${driver}`, 'GET');
      if (response?.isSuccess) {
        window.location.href = response.payload.scalar;
      } else {
        setAlertMessage({ alert: true, message: 'Failed to get social login URL. Please try again.' });
      }
    } catch (error) {
      console.error('Get social login URL error:', error);
      setAlertMessage({ alert: true, message: 'Failed to get social login URL. Please try again.' });
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className='social-login-box k-pt-2'>
     
      <Button
        fillMode='outline'
        imageUrl={MicrosoftLogo}
        imageAlt='Microsoft icon'
        className='microsoft-login-btn'
        onClick={() => handleSocialLogin('azure')}
      >
        Sign in with Microsoft
      </Button>
    </div>
  );
};

export default AzureLoginButton;
